export default __webpack_public_path__ + "static/media/agenda_icon.1b082c1d.svg";